export default "__VITE_ASSET__CnOA$$oZ__"